import { BaseApi } from "../base";

export default class ExportApi extends BaseApi {
  protected readonly prefix = "exports";

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  fetchScheduledReports = () => this.get("", { filter: "scheduled" });

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
  createReportOneTime = ({ email, format, encoding, type, dateFrom, dateTo }: any) =>
    this.post("", { email, format, encoding, type, date_from: dateFrom, date_to: dateTo });

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
  createReportRecurring = ({ email, format, encoding, type, period }: any) =>
    this.post("", { email, format, encoding, type, period });

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
  editScheduledReport = ({ email, format, encoding, type, period, typeCurrent, periodCurrent }: any) =>
    this.put("", { email, format, encoding, type, period, type_current: typeCurrent, period_current: periodCurrent });

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
  deleteScheduledReport = ({ type, recurs }: any) => this.delete("", { type, period: recurs });
}
